import { createReducer } from "@reduxjs/toolkit";
import {
  increment,
  decrement,
  productInfo,
  vendorDraftList,
  vendorDrafSuccess,
  vendorRetreievedPendingActions,
  storeCurrentReviewableAction,
  updateCurrentActionStatus,
  loadingActionRequests,
} from "../actions";
import { getInitialState } from "../store/defaultState";

const initial = getInitialState();
export const configReducer = createReducer(initial, {
  [increment]: (state, action) => {
    return { ...state, quantity: state.quantity + action.payload.val };
  },
  [decrement]: (state, action) => {
    return {
      ...state,
      quantity: state.quantity - action.payload.quantity,
    };
  },
  [productInfo]: (state, action) => {
    return {
      ...state,
      product: action.payload,
    };
  },
  [vendorDraftList]: (state, action) => {
    return {
      ...state,
      vendorDraftProducts: action.payload,
    };
  },
  [vendorDrafSuccess]: (state, action) => {
    return {
      ...state,
      vendorDraftProducts: action.payload,
    };
  },
  [vendorRetreievedPendingActions]: (state, action) => {
    return {
      ...state,
      vendorPendingActionRequests: action.payload,
    };
  },
  [storeCurrentReviewableAction]: (state, action) => {
    return {
      ...state,
      currentActionToReview: action.payload,
    };
  },
  [updateCurrentActionStatus]: (state, action) => {
    return {
      ...state,
      currentActionToReview: {
        ...state.currentActionToReview,
        status: action.payload,
      },
    };
  },
  [loadingActionRequests]: (state, action) => {
    return {
      ...state,
      loadingActionRequests: action.payload,
    };
  },
});